// D80 Tier 2 — central upload helper. Posts a file to the existing
// /api/media/upload endpoint (same one used by D66/D77) and returns
// a normalized { url, name, size, mime_type } payload that the
// NotionEditor's Image / Video / File nodes can consume.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export async function uploadNoteAsset(file, { workspaceId, maxBytes }) {
  if (!file) throw new Error('No file');
  if (maxBytes && file.size > maxBytes) {
    throw new Error(
      `File too large (${(file.size / 1024 / 1024).toFixed(1)} MB > ` +
      `${(maxBytes / 1024 / 1024).toFixed(0)} MB cap)`,
    );
  }
  const token = localStorage.getItem('stellar_token');
  const fd = new FormData();
  fd.append('file', file);
  if (workspaceId) fd.append('workspace_id', workspaceId);
  const r = await fetch(`${BACKEND}/api/media/upload`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: fd,
  });
  if (!r.ok) {
    const txt = await r.text().catch(() => '');
    throw new Error(`Upload failed (${r.status}): ${txt.slice(0, 200)}`);
  }
  const data = await r.json();
  return {
    url: data.url || data.public_url || data.path,
    name: file.name,
    size: file.size,
    mime_type: file.type || 'application/octet-stream',
    thumbnail_url: data.thumbnail_url || null,
  };
}

export function humanSize(bytes) {
  if (!bytes) return '0 B';
  const u = ['B', 'KB', 'MB', 'GB'];
  let i = 0; let n = bytes;
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${u[i]}`;
}
